import { render, staticRenderFns } from "./travel-insurance-policy.vue?vue&type=template&id=44cc1095&scoped=true"
import script from "./travel-insurance-policy.vue?vue&type=script&setup=true&lang=ts"
export * from "./travel-insurance-policy.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./travel-insurance-policy.vue?vue&type=style&index=0&id=44cc1095&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cc1095",
  null
  
)

export default component.exports